import URI from 'urijs';

export default function urlQueryParams(url) { 
    return new URI(url || document.URL).search(true);
}
